import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem, ITypedItem } from '../../../ts/ServerApi/types/resourceParts';
import { FlowListItem } from '../types/Flow';

export type GetFlowsParams = IGetItemsParams;

export type GetFlowsResult = IGetItemsResult & {
  flows?: FlowListItem[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  favorites?: string[];
  maxStats?: IUsageInfo;
};

export class GetFlowsRequest extends Request<GetFlowsParams, GetFlowsResult> {
  constructor(params: GetFlowsParams) {
    super('getFlows', params);
  }
}
